import config from '@/constants/config';

const REBOOK_RESERVATION_KEY = 'dm-rebook-reservation';
const REBOOK_MODE_KEY = 'dm-rebook-mode';

export function setRebookCode(code: string, timestamp?: number): void {
  if (typeof window === 'undefined') return;

  const ts = timestamp ?? Date.now();

  localStorage.setItem(REBOOK_MODE_KEY, ts.toString());
  localStorage.setItem(REBOOK_RESERVATION_KEY, code);

  const maxAgeSec = Math.floor(config.rebookCookieDuration / 1000);
  document.cookie = `${REBOOK_RESERVATION_KEY}=${code}; path=/; max-age=${maxAgeSec}; SameSite=Lax`;
}

export function getRebookCode(): { code: string; timestamp: number } | null {
  if (typeof window === 'undefined') return null;

  const code = localStorage.getItem(REBOOK_RESERVATION_KEY);
  const timestampStr = localStorage.getItem(REBOOK_MODE_KEY);

  if (!code || code === 'null' || !timestampStr) {
    return null;
  }

  const timestamp = parseInt(timestampStr, 10);
  const elapsed = Date.now() - timestamp;

  if (elapsed >= config.rebookCookieDuration) {
    clearRebookCode();
    return null;
  }

  return { code, timestamp };
}

export function clearRebookCode(): void {
  if (typeof window === 'undefined') return;

  localStorage.removeItem(REBOOK_RESERVATION_KEY);
  localStorage.removeItem(REBOOK_MODE_KEY);
  document.cookie = `${REBOOK_RESERVATION_KEY}=; path=/; max-age=0`;
}
